<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <i class=" mr-1"></i> Limites
                </h2>
            </div>
        </template>
        <div class="pb-12">
            <div class="grid grid-cols-12 gap-4 max-w-7xl mx-auto sm:px-6 lg:px-8 pt-8">
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Tranferência de Ted - Mesmo titular
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['ted_own']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Tranferência de Ted - Para Terceiros
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['ted_others']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Boleto - Mesmo titular
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['boleto_own']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Boleto - Para terceiros
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['boleto_others']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Pix - Mesmo titular
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['pix_own']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Pix - Para terceiros
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['pix_others']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Pagamentos - Mesmo titular e para terceiros
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['pagamentos_all']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" grid col-span-12 px-4 pt-2 text-xl font-bold">
                    Cash_in - Mesmo titular e para terceiros
                </div>
                <div class="grid col-span-6  bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4" v-for="limit in limits['cash_in_all']">
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'daily'">
                        Diário
                        <hr/>
                    </div>
                    <div class="grid col-span-12 px-4 pt-2 text-xl font-bold" v-if="limit['interval'] == 'monthly'">
                        Mensal
                        <hr/>
                    </div>
                    <div class="grid col-span-12 text-sm font-bold">
                        <div class="grid grid-cols-10 py-4 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                Unitário
                            </div>
                            <div class="grid col-span-2 text-center">
                                Quantidade
                            </div>
                            <div class="grid col-span-2 text-center">
                                Total
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Mínimo
                            </div>
                            <div class="grid col-span-2 text-center">
                                Valor Máximo
                            </div>
                        </div>
                        <div class="grid grid-cols-10 py-4 pb-6 gap-2 text-sm font-bold">
                            <div class="grid col-span-2 text-center">
                                {{ limit.single }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.quantity }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.total }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_min }}
                            </div>
                            <div class="grid col-span-2 text-center">
                                {{ limit.value_max }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
    import JetActionMessage from './../../Jetstream/ActionMessage'
    import JetButton from './../../Jetstream/Button'
    import JetFormSection from './../../Jetstream/FormSection'
    import JetInput from './../../Jetstream/Input'
    import JetInputError from './../../Jetstream/InputError'
    import JetLabel from './../../Jetstream/Label'
    import InertiaTable from "../../Helpers/Tables/InertiaTable";
    import AppLayout from './../../Layouts/AppLayout'
    import JetActionSection from './../../Jetstream/ActionSection'
    import JetSectionBorder from './../../Jetstream/SectionBorder'
    import JetDangerButton from './../../Jetstream/DangerButton'
    import JetDecimal from "../../Jetstream/Decimal";
    import JetConfirmationModal from "./../../Jetstream/ConfirmationModal"
    import JetTextarea from "../../Jetstream/Textarea"
    import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea"
    import JetAutoComplete from "../../Jetstream/AutoComplete"
    import JetSecondaryButton from "../../Jetstream/SecondaryButton"
    import JetMaskedInput from "../../Jetstream/MaskedInput"
    import JetFetchDoc from "../../Jetstream/FetchDoc"
    import Flash from "../../Helpers/Flash"
    import moment from 'moment/dist/moment'


export default {
    props: ['account', 'limits', 'type'],
    
    components: {
        AppLayout,
        Flash,
        InertiaTable,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetActionSection,
        JetDangerButton,
        JetDecimal,
        JetConfirmationModal,
        JetButton,
        JetFormSection,
        JetInput,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
    },
}
</script>
